import { IUserProfile } from './user-management';
export enum DocumentVerificationStatus {
  NOT_STARTED = 'notStarted',
  IN_PROGRESS = 'inProgress',
  PENDING_VERIFICATION = 'pendingVerification',
  VERIFIED = 'verified',
  NOT_VERIFIED = 'notVerified',
  NEEDS_REUPLOAD = 'needsReupload',
  NEEDS_CORRECTION = 'needsCorrection',
  NEEDS_REVIEW = 'needsReview',
}

export type DocumentVerificationStatusesLists = {
  transcript?: string;
  financialAidAwardLetter?: string;
  employmentAuthorizationDocument?: string;
  studentAidReportStatus?: string;
  thankYouLetterVideo?: string;
  enrollmentVerification?: string;
  headshot?: string;
  resume?: string;
  sat?: string;
  act?: string;
  ibExam?: string;
  apExam?: string;
};

export type DocumentVerificationStatuses = {
  headshot?: DocumentVerificationStatus;
  transcript?: DocumentVerificationStatus;
  financialAidAwardLetter?: DocumentVerificationStatus;
  employmentAuthorizationDocument?: DocumentVerificationStatus;
  studentAidReport?: DocumentVerificationStatus;
  thankYouLetterVideo?: DocumentVerificationStatus;
  enrollmentVerification?: DocumentVerificationStatus;
  resume?: DocumentVerificationStatus;
  sat?: DocumentVerificationStatus;
  act?: DocumentVerificationStatus;
  ibExam?: DocumentVerificationStatus;
  apExam?: DocumentVerificationStatus;
};

export interface IDocumentVerificationUser {
  id: string;
  userProfile: IUserProfile;
  formStatus: string;
  selectionPriority: string;
  verificationStatuses: any;
}

export type IStageUserForDocVerification = IDocumentVerificationUser & DocumentVerificationStatuses;

export interface IStageAutoassignedUserForDocVerification {
  userId: string;
}

export interface IStageUserInfoForDocVerification {
  users: IStageUserForDocVerification[];
  count: number;
}

export enum Priority {
  SELECTED = 'selected',
  WAITLIST1 = 'waitlist1',
  WAITLIST2 = 'waitlist2',
}

export enum DocumentVerificationType {
  TRANSCRIPT = 'transcript',
  FAAL = 'financialAidAwardLetter',
  EAD = 'employmentAuthorizationDocument',
  SAR = 'studentAidReport',
  THANK_YOU_LETTER_VIDEO = 'thankYouLetterVideo',
  EV = 'enrollmentVerification',
  ELECTRONIC_EV = 'electronic_ev',
  HEADSHOT = 'headshot',
  RESUME = 'resume',
  SAT = 'sat',
  ACT = 'act',
  OFFICIAL_SAT = 'official_sat',
  OFFICIAL_ACT = 'official_act',
  IB_EXAM = 'ibExam',
  AP_EXAM = 'apExam',
}

export enum EVReadOnlyFields {
  FILE_UPLOAD = 'fileUpload',
  UNIVERSITY_NAME = 'university_name',
  TERM_START_DATE = 'term_start_date',
  EV_FORM_TYPE = 'ev_form_type',
  CURRENT_EN_STATUS = 'current_enrollment_status',
}

export enum SATReadOnlyFields {
  FILE_UPLOAD = 'fileUpload',
  TOTAL_SCORE = 'total_score',
  MATH_SCORE = 'math_score',
  EBRW_SCORE = 'ebrw_score',
}

export enum ACTReadOnlyFields {
  FILE_UPLOAD = 'fileUpload',
  COMPOSITE_SCORE = 'composite_score',
}

export enum FileReadOnlyFields {
  FILE_UPLOAD = 'fileUpload',
}
